import BaseService from "../BaseService";

class PasswordReset extends BaseService {

  static NAME = 'PasswordReset';

}

export default PasswordReset;
